<div class="container text-center p-5">
    <div class="m-auto mt-3 pb-5">
        <app-logo></app-logo>
        <form [formGroup]="loginForm" (ngSubmit)="login()">
            <div class="mb-3">
                <label for="email" class="form-label">{{ 'login.email' | translate }}</label>
                <input type="email" id="email" formControlName="email" class="form-control" [class.is-invalid]="loginForm.get('email')?.touched && loginForm.get('email')?.invalid" required />
                <div *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid" class="invalid-feedback text-center">
                  <div *ngIf="loginForm.get('email')?.errors?.['required']">{{ 'login.email_required' | translate }}</div>
                  <div *ngIf="loginForm.get('email')?.errors?.['email']">{{ 'login.invalid_email_format' | translate }}</div>
                </div>
              </div>
              <div class="mb-3">
                <label for="exampleInputPassword" class="form-label">{{ 'login.password' | translate }}</label>
                <input type="password" id="exampleInputPassword" formControlName="password" class="form-control" [class.is-invalid]="loginForm.get('password')?.touched && loginForm.get('password')?.invalid" required />
                <div *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid" class="invalid-feedback text-center">
                  <div *ngIf="loginForm.get('password')?.errors?.['required']">{{ 'login.password_required' | translate }}</div>
                </div>
              </div>
              
            <br>
            <div *ngIf="errorMessage" class="text-danger mb-3">{{ errorMessage | translate }}</div>
            <button type="submit" class="btn btn-primary w-100 mt-3 px-5 fw-bold">{{ 'login.login' | translate }}</button>
        </form>
        <div class="mt-4">
            <p>
                <a routerLink="/register"
                    class="register-link text-white-50 link link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover">
                    {{ 'login.register' | translate }}
                </a>
                <span class="text-white-50 mx-1">|</span>
                <a routerLink="/forgotten-password"
                    class="forgot-password-link text-white-50 link link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover">
                    {{ 'login.forgotten_password' | translate }}
                </a>
            </p>
        </div>
    </div>
</div>